//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "CaO",
  data() {
    return {
      form: {
        pao: "",
        sao: "",
        hb: "",
      },
      hasScore: false,
      disabled: false,
     
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let multiple = 1
      let sumWater = ''
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            if (form[key] == "---") {
              flag = false;
            } else {
              form[key] = Number(form[key]);
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "--";
      } else {
    
        let result = (0.003*form.pao + 1.34*form.sao*form.hb).toFixed(2)
        self.hasScore = true;
        return result;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/CaO.vue